const Trending = () => {
    return (
        <svg
            width={16}
            height={21}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                opacity=".4"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.615 7.2C15.132 8.51 16 10.117 16 12.321c0 4.59-3.587 8.206-7.989 8.206C3.606 20.527 0 16.909 0 12.32c0-2.527.548-4.089 2.155-6.684.509-.822 1.744-.523 1.84.445.085.87.35 1.61.734 2.177C4.472 5.193 5.804 1.744 9.086.106c.76-.38 1.608.319 1.41 1.16-.512 2.183.016 3.356 1.396 4.621.034.031.206.158.433.326.412.304 1.006.742 1.29.987ZM2.621 9.007C2.339 9.663 2 10.453 2 12.321c0 3.447 2.701 6.157 6.011 6.157 3.305 0 5.989-2.705 5.989-6.157 0-1.54-.575-2.605-1.674-3.554-.174-.15-.58-.452-.963-.737-.362-.27-.702-.522-.804-.616C9.234 6.2 8.424 4.907 8.314 3.184c-.67.668-2.21 2.748-1.342 6.864.134.639-.34 1.241-.977 1.241-1.265 0-2.515-.99-3.279-2.507-.03.074-.062.149-.095.225Z"
                fill="#fff"
            />
        </svg>
    );
};

export default Trending;
